// Copyright (c) Docugami, Inc. All rights reserved.

import { useEffect } from "react";
import { selectReportDocumentId, selectReportDocumentsState } from "store/reports/selectors";
import { NavigationType, useNavigationService } from "./navigationService";
import { useAppSelector } from "./redux";

export function useTargetReportDocument(fallbackId?: string): void {
    const documentId = useAppSelector(selectReportDocumentId);
    const documents = useAppSelector(selectReportDocumentsState)
    const nav = useNavigationService();

    useEffect(() => {
        if (!!documents) {
            const currentId = !!documentId ? documentId : fallbackId ?? ''
            const targetId = documents.entities[currentId]?.folderId ?? documents.ids[0];

            if (!!targetId && targetId !== documentId) {
                nav.navToReportPage(
                    NavigationType.ReplaceCurrentPage, {
                        documentId: targetId as string
                    }
                );
            }
        }
    }, [documents, documentId, fallbackId, nav])
}
